const programmingSkills = [
    { skill: "C#", ratingPercentage: 85 },
    { skill: ".NET", ratingPercentage: 80 },
    { skill: "SQL", ratingPercentage: 85 },
    { skill: "Redis", ratingPercentage: 75 },
    { skill: "RabbitMQ", ratingPercentage: 80 },
    { skill: "Kafka", ratingPercentage: 80 },
    { skill: "HTML", ratingPercentage: 75 },
    { skill: "CSS", ratingPercentage: 75 },
    { skill: "JavaScript", ratingPercentage: 70 },
    { skill: "React JS", ratingPercentage: 65 },
    { skill: "Docker", ratingPercentage: 75 },
    { skill: "Openshift", ratingPercentage: 70 },
    { skill: "Prometheus", ratingPercentage: 70 },
    { skill: "Grafana", ratingPercentage: 70 },
    { skill: "Git", ratingPercentage: 85 },
    { skill: "GraphQL", ratingPercentage: 65 },
    { skill: "Claude Code", ratingPercentage: 77 },
];

const resumeBullets = [
    { label: "Work History", logo: "briefcase" },
    { label: "Education", logo: "school" },
    { label: "Skills", logo: "laptop" },
];


export {
    programmingSkills, resumeBullets
};

